import { MediaRecorder, load } from "@zappar/mediarecorder";
import {
  changeCameraButtonTextPhotoOnly,
  hideLoadingPage,
  hidePhotofeature,
  revealDownloadPage,
  revealLoadingPage,
  startCameraButtonAnim,
  stopCameraButtonAnim,
} from "../dom";
import { sendTrackingEvent } from "../utils";

const clickSrc = new URL("../assets/audio/click.mp3", import.meta.url).href;
let click = new Audio(clickSrc);
const laughSrc = new URL("../assets/audio/laugh.mp3", import.meta.url).href;
const roarSrc = new URL("../assets/audio/roar.mp3", import.meta.url).href;
const musicSrc = new URL("../assets/audio/music.mp3", import.meta.url).href;

let laughIsPlaying = false;
let roarIsPlaying = false;
let musicIsPlaying = false;

let laugh: AudioBufferSourceNode;
let roar: AudioBufferSourceNode;
let music: AudioBufferSourceNode;

let audioBufferLaugh: AudioBuffer;
let audioBufferRoar: AudioBuffer;
let audioBufferMusic: AudioBuffer;

const cameraButton = <HTMLButtonElement>document.querySelector(".cameraButton");
const saveButton = <HTMLButtonElement>document.querySelector(".saveButton");
const shareButton = <HTMLButtonElement>document.querySelector(".shareButton");
const downloadImage = <HTMLImageElement>document.querySelector(".downloadImage");
const downloadVideo = <HTMLVideoElement>document.querySelector(".downloadVideo");

let vidTimerComplete = false;
let vidTimeout: ReturnType<typeof setTimeout>;
let isVid = false;

let imgData: string;
let renderer: THREE.Renderer;

let recording: boolean;

let canvas: HTMLCanvasElement;
let recorder: MediaRecorder;
let canvasStream: MediaStream;

let data: Blob[] = [];
let vidData: any;
let recorderError = false;

let ctx: AudioContext;

let videoPlaying = false;

let outputGainNode: GainNode;

export async function initVideoRecorder(Renderer: THREE.Renderer) {
  // downloadVideo.muted = true;
  renderer = Renderer;

  canvas = document.querySelector("canvas")!;
  canvas.width += canvas.width % 2;
  canvas.height += canvas.height % 2;
  canvasStream = canvas.captureStream(30);
  console.log('Canvas dimensions', canvas.width, canvas.height);

  ctx = new AudioContext();

  const requestMusic = await fetch(musicSrc)
  const dataMusic = await requestMusic.arrayBuffer();
  audioBufferMusic = await ctx.decodeAudioData(dataMusic);

  const requestLaugh = await fetch(laughSrc)
  const dataLaugh = await requestLaugh.arrayBuffer();
  audioBufferLaugh = await ctx.decodeAudioData(dataLaugh);

  const requestRoar = await fetch(roarSrc)
  const dataRoar = await requestRoar.arrayBuffer();
  audioBufferRoar = await ctx.decodeAudioData(dataRoar);

  music = resetAudio(music, audioBufferMusic)
  roar = resetAudio(roar, audioBufferRoar)
  laugh = resetAudio(laugh, audioBufferLaugh)


  outputGainNode = new GainNode(ctx);
  outputGainNode.connect(ctx.destination);


  music.connect(outputGainNode);
  laugh.connect(outputGainNode);
  roar.connect(outputGainNode);

  let dest = ctx.createMediaStreamDestination();
  outputGainNode.connect(dest);

  let audioTrackMusic = dest.stream.getAudioTracks()[0];
  canvasStream.addTrack(audioTrackMusic)

  resetVideo();
}

function resetAudio(audioBufferSourceNode: AudioBufferSourceNode, audioBuffer: AudioBuffer) {
  audioBufferSourceNode?.disconnect()
  audioBufferSourceNode = ctx.createBufferSource();
  audioBufferSourceNode.buffer = audioBuffer;
  audioBufferSourceNode.connect(ctx.destination);
  return audioBufferSourceNode;
}

downloadVideo.addEventListener("playing", () => {
  if (recording) {
    recording = false;
    hideLoadingPage();
    revealDownloadPage(isVid);
  }
});

cameraButton?.addEventListener("pointerdown", async () => {
  vidTimerComplete = false;
  vidTimeout = setTimeout(() => {
    if (recorder != null && !recorderError) {
      console.log("Video recording started");
      startCameraButtonAnim();
      vidTimerComplete = true;

      canvas.width += canvas.width % 2;
      canvas.height += canvas.height % 2;

      recorder.start();
      recording = true;
    }
  }, 300);

  setTimeout(() => {
    console.log("recorder stop after timeout");
    if (recording) recorder.stop();
  }, 15000);
});

cameraButton?.addEventListener("pointerup", async () => {
  isVid = vidTimerComplete;
  clearTimeout(vidTimeout);
  if (recording) {
    console.log("recorder stop on pointer up");
    recorder.stop();
    sendTrackingEvent("User held to record a video");
  } else {
    imgData = renderer.domElement.toDataURL("image/png", 0.8);
    downloadImage.src = imgData;
    hidePhotofeature();
    revealDownloadPage(isVid);
    sendTrackingEvent("User tapped to take a photo");
  }
});

shareButton?.addEventListener("pointerdown", async () => {
  sendTrackingEvent("User tapped save & share button");
  let data = isVid ? vidData : imgData;

  navigatorShare(data);
});

saveButton?.addEventListener("pointerdown", async () => {
  sendTrackingEvent("User tapped save & share button");
  let data = isVid ? vidData : imgData;
  const image = await fetch(data);
  const blob = await image.blob();
  saveToDownloads(blob);
});

function blobToDataURL(blob: Blob): Promise<string> {
  return new Promise(resolve => {
    const a = new FileReader();
    a.onload = evt => resolve(a.result as string);
    a.readAsDataURL(blob);
  });
}

export async function navigatorShare(data: any) {
  const image = await fetch(data);
  const blob = await image.blob();
  let file: any;
  if (isVid) {
    file = new File([blob], "sesamestreettoys.mp4", { type: "video/mp4" });
  } else {
    file = new File([blob], "sesamestreettoys.jpg", { type: "image/jpeg" });
  }

  if (
    blob &&
    navigator.canShare &&
    navigator.canShare({
      text: "Dino-mite! Dancing like a dinosaur with Dino Stomp Elmo is a blast! Click the link to try it!",
      title: "Sesame Street Toy File",
      files: [file],
    })
  ) {
    await navigator
      .share({
        text: "Dino-mite! Dancing like a dinosaur with Dino Stomp Elmo is a blast! Click the link to try it!",
        title: "Sesame Street Toy File",
        files: [file],
      })
      .catch(error => {
        console.warn("Sharing failed", error);
      });
  } else {
    console.log(`Your system doesn't support sharing files.`);
    if (isVid) {
      saveToDownloads(blob);
    } else {
      saveToDownloads(blob);
    }
  }
}

function saveToDownloads(blob: any) {
  const imageURL = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = imageURL;
  link.download = "#sesamestreettoys";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function stopRecording() {
  if (recording) {
    recorder.stop();
  }
}

export function resetVideo() {
  videoPlaying = false;
  // downloadVideo.muted = true;
  downloadVideo.pause();
  downloadVideo.removeAttribute("src"); // empty source
  downloadVideo.load();
  vidData = "";
  data = [];

  try {
    recorder = new MediaRecorder(canvasStream, { mimeType: "video/mp4" });
  } catch (err) {
    console.log("Error creating Media Recorder");
    changeCameraButtonTextPhotoOnly();
  }



  if (recorder != null && !recorderError) {

    recorder.onerror = (err: any) => {
      console.log('error recording stream: ' + err.message);
      recorderError = true;
    };

    if (!recorderError) {
      recorder.ondataavailable = evt => {
        data.push(evt.data);
        changeCameraButtonTextPhotoOnly();
      };

      recorder.onstop = async evt => {
        console.log("Recorder.onStop");
        music.stop();
        revealLoadingPage();
        stopCameraButtonAnim();
        isVid = vidTimerComplete;
        vidData = await blobToDataURL(new Blob(data, { type: "video/mp4" }));
        downloadVideo.src = vidData;
        videoPlaying = true;
        downloadVideo.play();
        // downloadVideo.muted = false
      };
    }
  }
}
export function resumeAudioContext() {
  ctx?.resume();
}



//AUDIO
export function playClickSound() {

  click.play();
}

export function playMusic() {
  console.log('play music')
  ctx.resume()
  if (!musicIsPlaying) {
    musicIsPlaying = true;
    music?.start();
    music.loop = true;
  }
  music.addEventListener("ended", () => {
    console.log('music ended')
    musicIsPlaying = false;
    music = resetAudio(music, audioBufferMusic)
  });
}

export function playLaughSound() {
  console.log('play laugh')
  if (!laughIsPlaying && !videoPlaying) {
    laughIsPlaying = true;
    laugh?.start();
  }
  laugh.addEventListener("ended", () => {
    console.log('laugh ended')
    laughIsPlaying = false;
    laugh = resetAudio(laugh, audioBufferLaugh)
  });
}


export function playRoarSound() {
  console.log('play roar')
  if (!roarIsPlaying && !videoPlaying) {
    roarIsPlaying = true;
    roar?.start();
  }
  roar.addEventListener("ended", () => {
    console.log('roar ended')
    roarIsPlaying = false;
    roar = resetAudio(roar, audioBufferRoar)
  })
}



export function initTabVisibiltyListenerForAudio() {
  document.addEventListener("visibilitychange", event => {
    outputGainNode.gain.value = document.visibilityState == "visible" ? 1 : 0;
    click.muted = document.visibilityState == "visible" ? false : true;

  });
}

